import React, { useContext } from 'react'
import styled from 'styled-components'

import FacebookIcon from '@Assets/SVG/SocialMedia/Facebook'
import InstagramIcon from '@Assets/SVG/SocialMedia/Instagram'
import YoutubeIcon from '@Assets/SVG/SocialMedia/Youtube'
import { FooterElement, SectionTitle } from '@Components/Footer/styled'
import { SVGIcon } from '@Components/Icons'
import { MetadataContext } from '@Globals/Metadata'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

interface WrapperProps {
  textColor?: string
}

const Wrapper = styled(FooterElement)<WrapperProps>`
  order: 5;

  ${up('tablet')} {
    order: 6;
  }

  .text a {
    color: ${({ textColor, theme }) => textColor ?? theme.colors.primary};
    text-decoration: underline;
  }
`

export const Story = () => {
  const { t, tDanger } = useTranslation()
  const { cmsData } = useContext(MetadataContext)

  return (
    <Wrapper>
      <SectionTitle>{t('footer:GET_TO_KNOW_US')}</SectionTitle>
      <p
        className="text"
        {...tDanger('footer:TRENDHIM_STORY_INTRO_TEXT', { arg1: cmsData?.urls?.aboutUs })}
      />
      <SectionTitle style={{ marginTop: '20px' }}>{t('footer:FIND_US')}</SectionTitle>
      <div className="container">
        <a
          className="row"
          href="https://www.facebook.com/trendhim"
          rel="noopener noreferrer"
          target="_blank"
        >
          <SVGIcon icon={FacebookIcon} />
          <div className="itemText">{t('footer:FACEBOOK_LABEL')}</div>
        </a>
        <a
          className="row"
          href="https://www.youtube.com/trendhim"
          rel="noopener noreferrer"
          target="_blank"
        >
          <SVGIcon icon={YoutubeIcon} />
          <div className="itemText">{t('footer:YOUTUBE_LABEL')}</div>
        </a>
        <a
          className="row"
          href="https://www.instagram.com/trendhim"
          rel="noopener noreferrer"
          target="_blank"
        >
          <SVGIcon icon={InstagramIcon} />
          <div className="itemText">{t('footer:INSTAGRAM_LABEL')}</div>
        </a>
      </div>
    </Wrapper>
  )
}
